"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalInputFactory = void 0;
const TreePicker_1 = require("./TreePicker");
const ZoomWindow_1 = require("./ZoomWindow");
const RefDialog_1 = require("./RefDialog");
const AddressListDialog_1 = require("./AddressListDialog");
const MapInputWindow_1 = require("./MapInputWindow");
const FtEditor_1 = require("./FtEditor");
const ExternalInputFactoryCustomer_1 = require("./ExternalInputFactoryCustomer");
const FtolNewMask_1 = require("./FtolNewMask");
const MVPickerAlternative1_1 = require("./MVPickerAlternative1");
/**
* Factory for all external inputs, based on the syneris method id
*/
class ExternalInputFactory {
    /**
    * Creates an external input for the given external input menuentry.
    *
    * @param methodName Internal name of the external input menuentry
    * @param controlColl Input/Static/Button of the control that triggered the
    * external input. Input and Static have to be supplied!
    * @return {ExternalInput} A new ExternalInput-derived object
    */
    static create(methodName, controlColl, currentInstance) {
        switch (methodName) {
            case "cefunc.174":
                return new TreePicker_1.TreePicker(controlColl, currentInstance, methodName);
            case "cefunc.173":
                return new ZoomWindow_1.ZoomWindow(controlColl, currentInstance, methodName);
            case "ceforeigntableext.4":
            case "ceforeigntableext.6":
                return new RefDialog_1.RefDialog(controlColl, currentInstance, methodName);
            case "mailext.28":
                return new AddressListDialog_1.AddressListDialog(controlColl, currentInstance, methodName);
            case "cefunc.207":
                return new MapInputWindow_1.MapInputWindow(controlColl, currentInstance, methodName);
            case "cefunc.217":
                return new FtEditor_1.FtEditor(controlColl, currentInstance, methodName);
            case "cefunc.233":
                return new FtolNewMask_1.FtolNewMask(controlColl, currentInstance, methodName);
            case "cefunc.249":
                return new MVPickerAlternative1_1.MVPickerAlternative1(controlColl, currentInstance, methodName);
            default:
                return ExternalInputFactoryCustomer_1.ExternalInputFactoryCustomer.create(methodName, controlColl, currentInstance);
        }
    }
}
exports.ExternalInputFactory = ExternalInputFactory;
